// extracted by mini-css-extract-plugin
export default {"modalWrapper":"InstallmentPlanModal_modalWrapper__XoVOs"};